export default "__VITE_ASSET__Y2qsTS89__"